<mat-spinner diameter="36"></mat-spinner>
<app-dialog-title
	*ngFor="let request of requests"
	[title]="request"
	state="default"
></app-dialog-title>
